import React, { useEffect, useState } from 'react';
import { API_BASE } from '../config';

const downloadUrlByResourceId = new Map<string, string>();

export const S3ResourceImage: React.FC<{
  projectId: string;
  resourceId: string;
  token: string;
  title: string;
  className: string;
  alt?: string;
}> = ({ projectId, resourceId, token, title, className, alt = '' }) => {
  const [src, setSrc] = useState<string | null>(() => downloadUrlByResourceId.get(resourceId) ?? null);
  const [showTitle, setShowTitle] = useState(false);

  useEffect(() => {
    const cached = downloadUrlByResourceId.get(resourceId);
    if (cached) {
      setSrc(cached);
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const response = await fetch(`${API_BASE}/api/projects/${projectId}/resources/${resourceId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
          if (!cancelled) {
            setShowTitle(true);
          }
          return;
        }
        const data = (await response.json()) as { downloadUrl?: string | null };
        const u = data.downloadUrl;
        if (!cancelled) {
          if (u) {
            downloadUrlByResourceId.set(resourceId, u);
            setSrc(u);
          } else {
            setShowTitle(true);
          }
        }
      } catch {
        if (!cancelled) {
          setShowTitle(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [projectId, resourceId, token]);

  if (showTitle) {
    return (
      <span className="px-2 text-center text-sm font-medium text-foreground">{title}</span>
    );
  }

  if (!src) {
    return <div className={`animate-pulse rounded-md bg-muted ${className}`} aria-hidden />;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        setShowTitle(true);
      }}
    />
  );
};
